import { useState, useEffect } from "react"

const useSearchLocal = (searchGroup = "default") => {
	const getStorageKey = (key) => `search_${searchGroup}_${key}`
	
	const [searchData, setSearchData] = useState({
		search: "",
		qualification: "all",
		status: "all",
		// voucherType: "all"
	})

	useEffect(() => {
		const storedData = {
			search: localStorage.getItem(getStorageKey("search")) || "",
			qualification: localStorage.getItem(getStorageKey("qualification")) || "all",
			status: localStorage.getItem(getStorageKey("status")) || "all",
			// voucherType: localStorage.getItem(getStorageKey("voucherType")) || "all"
		}
		setSearchData(storedData)
	}, [searchGroup])

	const saveToLocal = (key, value) => {
		if (value && value !== "all" && value !== "") {
			localStorage.setItem(getStorageKey(key), value)
		} else {
			localStorage.removeItem(getStorageKey(key))
		}
		setSearchData(prev => ({ ...prev, [key]: value }))
	}

	const clearLocal = () => {
		localStorage.removeItem(getStorageKey("search"))
		localStorage.removeItem(getStorageKey("qualification"))
		localStorage.removeItem(getStorageKey("status"))
		// localStorage.removeItem(getStorageKey("voucherType"))
		setSearchData({
			search: "",
			qualification: "all",
			status: "all",
			// voucherType: "all"
		})
	}

	return [searchData, saveToLocal, clearLocal]
}

export default useSearchLocal